/*
 * 
 * Product Util Service
 * 
*/
import { Injectable } from '@angular/core';
import { IDisplayableElements, IConfigObj, ProductModel, BadgeModel } from '../models/data.model';
import { UOM_ABBREVIATIONS } from '../constants/constants';
import { AemService } from './aem.service';

// Window global declaration
function _window(): any {
    return window;
}
declare let $: any;

interface AvailabilityTimes {
    fulfillmentStartTime: string;
    fulfillmentEndTime: string;
    fulfillmentStartTimeSaturday: string;
    fulfillmentEndTimeSaturday: string;
    fulfillmentStartTimeSunday: string;
    fulfillmentEndTimeSunday: string;
};

const CHANNEL_LABEL_PICKUP_ONLY = 'Pickup only';
const CHANNEL_LABEL_DELIVERY_ONLY = 'Delivery only';
const CHANNEL_LABEL_INSTORE_ONLY = 'In-store only';

@Injectable()
export class ProductUtilService {
    public constructor(
        private aemService: AemService
    ) { }

    public getProductDisplayableElementsByProgramType(programType: string): IDisplayableElements {
        const objFeaturesByProgramType = {
            mkp: {
                estimateLabel: false,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: false,
                unattendedDeliveryLabel: false,
                mto: false,
                coupons: false,
                addToCart: true,
                scheduleNSave: false,
                buyItAgain: true,
                starRating: true,
                price: true,
                viewSimilarItemsLink: false,
                image: true,
                title: true,
                sellerTag: true,
                prop65Title: true,
                nestedFulfillment: false,
                promoText: true,
                snapEligible : false
            },
            wineshop: {
                estimateLabel: true,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: true,
                unattendedDeliveryLabel: true,
                mto: true,
                coupons: false,
                addToCart: true,
                scheduleNSave: false,
                buyItAgain: true,
                starRating: true,
                price: true,
                viewSimilarItemsLink: true,
                image: true,
                title: true,
                sellerTag: false,
                prop65Title: true,
                nestedFulfillment: true,
                promoText: true,
                snapEligible : false
            },
            abs:  {
                estimateLabel: true,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: true,
                unattendedDeliveryLabel: true,
                mto: true,
                coupons: true,
                addToCart: true,
                scheduleNSave: true,
                buyItAgain: true,
                starRating: true,
                price: true,
                viewSimilarItemsLink: true,
                image: true,
                title: true,
                sellerTag: false,
                prop65Title: true,
                nestedFulfillment: true,
                promoText: true,
                snapEligible : true
            },
            'bia-category-carousel':  {
                estimateLabel: true,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: true,
                unattendedDeliveryLabel: true,
                mto: true,
                coupons: true,
                addToCart: true,
                scheduleNSave: true,
                buyItAgain: false,
                starRating: true,
                price: true,
                viewSimilarItemsLink: true,
                image: true,
                title: true,
                sellerTag: false,
                prop65Title: true,
                nestedFulfillment: true,
                promoText: true,
                snapEligible : true
            },
            '1P_B2B':  {
                estimateLabel: true,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: true,
                unattendedDeliveryLabel: true,
                mto: true,
                coupons: true,
                addToCart: true,
                scheduleNSave: true,
                buyItAgain: true,
                starRating: true,
                price: true,
                viewSimilarItemsLink: true,
                image: true,
                title: true,
                sellerTag: false,
                snapEligible : false
            },
            '1P_B2B_bia-category-carousel':  {
                estimateLabel: true,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: true,
                unattendedDeliveryLabel: true,
                mto: true,
                coupons: true,
                addToCart: true,
                scheduleNSave: true,
                buyItAgain: false,
                starRating: true,
                price: true,
                viewSimilarItemsLink: true,
                image: true,
                title: true,
                sellerTag: false,
                snapEligible : false
            },
            weeklyAd: {
                estimateLabel: true,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: true,
                unattendedDeliveryLabel: true,
                mto: true,
                coupons: false,
                addToCart: true,
                scheduleNSave: false,
                buyItAgain: true,
                starRating: true,
                price: true,
                viewSimilarItemsLink: true,
                image: true,
                title: true,
                sellerTag: false,
                snapEligible : false
            },
            'wine-carousel':  {
                estimateLabel: false,
                sponsoredLabel: false,
                itemNotAvailable: false,
                availableInStoreLabel: false,
                unattendedDeliveryLabel: false,
                mto: false,
                coupons: false,
                addToCart: false,
                scheduleNSave: false,
                buyItAgain: false,
                starRating: false,
                price: false,
                viewSimilarItemsLink: false,
                image: true,
                title: true,
                sellerTag: false,
                prop65Title: true,
                nestedFulfillment: true,
                promoText: true,
                snapEligible : false
            },
            'mkp-carousel':  {
                estimateLabel: false,
                sponsoredLabel: false,
                itemNotAvailable: true,
                availableInStoreLabel: false,
                unattendedDeliveryLabel: false,
                mto: false,
                coupons: false,
                addToCart: true,
                scheduleNSave: false,
                buyItAgain: false,
                starRating: true,
                price: true,
                viewSimilarItemsLink: false,
                image: true,
                title: true,
                sellerTag: true,
                prop65Title: true,
                nestedFulfillment: false,
                promoText: true,
                snapEligible : false
            },
            'light-weight':  {
                estimateLabel: false,
                sponsoredLabel: false,
                itemNotAvailable: false,
                availableInStoreLabel: false,
                unattendedDeliveryLabel: false,
                mto: false,
                coupons: false,
                addToCart: true,
                scheduleNSave: false,
                buyItAgain: false,
                starRating: false,
                price: true,
                viewSimilarItemsLink: false,
                image: true,
                title: true,
                sellerTag: false,
                prop65Title: false,
                nestedFulfillment: false,
                promoText: false,
                snapEligible : false
            },
            '1P_SNS':  {
                estimateLabel: true,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: true,
                unattendedDeliveryLabel: true,
                mto: false,
                coupons: true,
                addToCart: true,
                scheduleNSave: false,
                buyItAgain: true,
                starRating: true,
                price: true,
                viewSimilarItemsLink: true,
                image: true,
                title: true,
                sellerTag: true,
                prop65Title: true,
                nestedFulfillment: true,
                promoText: true,
                snapEligible : true
            },
            'light-weight-sponsored':  {
                estimateLabel: false,
                sponsoredLabel: true,
                itemNotAvailable: false,
                availableInStoreLabel: false,
                unattendedDeliveryLabel: false,
                mto: false,
                coupons: true,
                addToCart: true,
                scheduleNSave: false,
                buyItAgain: false,
                starRating: false,
                price: true,
                viewSimilarItemsLink: false,
                image: true,
                title: true,
                sellerTag: false,
                prop65Title: false,
                nestedFulfillment: false,
                promoText: false,
                snapEligible : false
            },
            dnf: {
                estimateLabel: true,
                sponsoredLabel: true,
                itemNotAvailable: true,
                availableInStoreLabel: true,
                unattendedDeliveryLabel: true,
                mto: true,
                coupons: true,
                addToCart: true,
                scheduleNSave: true,
                buyItAgain: false,
                starRating: false,
                price: true,
                viewSimilarItemsLink: true,
                image: true,
                title: true,
                sellerTag: false,
                prop65Title: true,
                nestedFulfillment: true,
                promoText: true,
                snapEligible : true
            }
        };

        return programType ? objFeaturesByProgramType[programType] : objFeaturesByProgramType['abs'];
    }

    /**
   * Get Banner Domain Url
   * 
   * @returns bannerDomain
   */
    public getBannerDomainUrl(configObj: IConfigObj): string {
        const {banner} = window['AB']['userInfo'];
        if (configObj?.bannerDomain) {
            return configObj?.bannerDomain?.replace('${banner}', banner);
        }
        return '';
    }

    private formatTime24to12(time: string): string {
        const [hour, minute] = time.split(':').map(Number);
        const period = hour >= 12 ? 'PM' : 'AM';
        const formattedHour = hour % 12 || 12; // Convert 0 to 12 for 12 AM
        const formattedMinute = minute === 0 ? '' : `:${minute.toString().padStart(2, '0')}`;
        return `${formattedHour}${formattedMinute} ${period}`;
    }
    
    private getAvailabilityTimes(availabilityTimes: AvailabilityTimes): string {
        const weekdayTimes = {
            start: availabilityTimes?.fulfillmentStartTime,
            end: availabilityTimes?.fulfillmentEndTime
        };
    
        const weekendTimes = {
            Saturday: { start: availabilityTimes?.fulfillmentStartTimeSaturday, end: availabilityTimes?.fulfillmentEndTimeSaturday },
            Sunday: { start: availabilityTimes?.fulfillmentStartTimeSunday, end: availabilityTimes?.fulfillmentEndTimeSunday }
        };
    
        const today = new Date().toLocaleString('en-US', { weekday: 'long' });
        let startTime, endTime;
    
        if (today === 'Saturday' || today === 'Sunday') {
            startTime = weekendTimes[today]?.start;
            endTime = weekendTimes[today]?.end;
        } else {
            startTime = weekdayTimes?.start;
            endTime = weekdayTimes?.end;
        }

        if (!startTime || !endTime || (startTime === '00:00' && endTime === '00:00')) {
            return '';
        }
    
        const formattedStartTime = startTime === '00:00' ? 'Before' : this.formatTime24to12(startTime);
        const formattedEndTime = endTime === '23:59' ? 'After' : this.formatTime24to12(endTime);
    
        if (startTime === '00:00') {
            return `${formattedStartTime} ${formattedEndTime} only`;
        } else if (endTime === '23:59') {
            return `${formattedEndTime} ${formattedStartTime} only`;
        } else {
            return `${formattedStartTime}–${formattedEndTime} only`;
        }
    }


    /**
    * This method will return product tags for size, packageqty, preptime and snap for product cards 
    * and carosel cards
    * @param product
    * @param displayableElements
    * @param isCarousel
    * @returns array of product size tags
    */
    public productTagElements(product: ProductModel, displayableElements: IDisplayableElements, isCarousel?: boolean) {

        let pcTags = [];

        if (!this.aemService.getFeatureFlagByNameDisable('isMtoChannelEligibilityEnabled')) {
            pcTags = this.productTagElementsFromLabels(product, displayableElements);
        }
        else {
            const { dispItemPackageQty, dispItemPackageUOM, dispItemSizeQty, dispUnitOfMeasure,
                isMtoProduct, mtoTagText, mtoDisplyableTime, snapEligible,
                fulfillmentStartTime, fulfillmentEndTime, fulfillmentStartTimeSaturday, fulfillmentEndTimeSaturday,
                fulfillmentStartTimeSunday, fulfillmentEndTimeSunday } = product;

            // Package quantity tag
            if (dispItemPackageQty > 1) {
                pcTags.push({
                    type: 'packageqty',
                    displayableText: `${dispItemPackageQty} ${dispItemPackageUOM ? dispItemPackageUOM.toLocaleLowerCase() : 'ct'}`,
                    srOnlyText: `${dispItemPackageQty} count`,
                    qaAttribute: 'prd-itm-pqty',
                });
            }
            // Size quantity tag
            if (dispItemSizeQty > 0 && dispUnitOfMeasure) {
                const uom = UOM_ABBREVIATIONS[dispUnitOfMeasure.replace(' ', '').toLocaleLowerCase()];
                pcTags.push({
                    type: 'sqty',
                    displayableText: `${parseFloat(dispItemSizeQty.toString())} ${dispUnitOfMeasure.toLocaleLowerCase()}`,
                    srOnlyText: `${parseFloat(dispItemSizeQty.toString())} ${uom}`,
                    qaAttribute: 'prd-itm-sqty',
                });
            }

            // MTO tag
            if (displayableElements?.mto && isMtoProduct && mtoTagText) {
                pcTags.push({
                    type: 'mto',
                    displayableText: mtoTagText,
                    srOnlyText: `${mtoDisplyableTime} preparation time`,
                    qaAttribute: 'qty-stppr-mto',
                });
            }

            //Availability tag
            const availabilityText = this.getAvailabilityTimes({ fulfillmentStartTime, fulfillmentEndTime, fulfillmentStartTimeSaturday, fulfillmentEndTimeSaturday, fulfillmentStartTimeSunday, fulfillmentEndTimeSunday });
            if (availabilityText) {
                pcTags.push({
                    type: 'availability',
                    displayableText: availabilityText,
                    srOnlyText: `Available ${availabilityText.replace("–", " to ")}`,
                    qaAttribute: 'prd-itm-availability',
                });
            }

            // SNAP tag
            if (displayableElements?.snapEligible && snapEligible && !isCarousel) {
                pcTags.push({
                    type: 'snap',
                    displayableText: 'SNAP',
                    qaAttribute: 'prd-itm-snap',
                });
            }
        }

        return isCarousel ? pcTags.slice(0,2) : pcTags.slice(0,3);
    }

    /**
    * This method will return product tags based on the labels provided in the product object
    * @param product
    * @param displayableElements
    * @returns array of product size tags
    */
    private productTagElementsFromLabels(product: ProductModel, displayableElements: IDisplayableElements) {
        const pcTags = [];

        const {fulfillmentStartTime, fulfillmentEndTime, fulfillmentStartTimeSaturday, fulfillmentEndTimeSaturday, 
            fulfillmentStartTimeSunday, fulfillmentEndTimeSunday, labels}  = product;

        if (labels && labels.length > 0) {
            labels.forEach(label => {
                if (label.isLabelAppOnly) return;
                
                let labelName = label.labelName;
                let accessibilityText = label.accessibilityText;
                let qaAttribute = `prd-itm-${labelName.toLocaleLowerCase().replace(/\s+/g, '-')}`;

                // If accessibility text is not provided, use the label name as the accessibility text
                if (!accessibilityText) {
                    accessibilityText = labelName;
                }

                // Check if the label/accessibilityText is a token/placeholder
                if (label.replacePlaceholder) {
                    if (labelName === '(availabilityText)') {
                        labelName = this.getAvailabilityTimes({ fulfillmentStartTime, fulfillmentEndTime, fulfillmentStartTimeSaturday, fulfillmentEndTimeSaturday, fulfillmentStartTimeSunday, fulfillmentEndTimeSunday });
                        accessibilityText = `Available ${labelName.replace("–", " to ")}`;
                        qaAttribute = 'prd-itm-availability';
                    }
                    else if (labelName === '(channelAvailability)') {
                        labelName = this.getChannelAvailabilityLabel(product);
                        accessibilityText = labelName;
                        qaAttribute = 'prd-itm-fulfillment-type';
                    }
                }
                
                if (labelName) {
                    pcTags.push({
                        displayableText: labelName,
                        srOnlyText: accessibilityText,
                        qaAttribute: qaAttribute
                    });
                }
            });
        }

        return pcTags;
    }

    /**
     * Determines the channel availability label for a product based on its channel eligibility.
     *
     * @param product - The product object containing channel eligibility information.
     * @returns The channel availability label as a string.
     */
    private getChannelAvailabilityLabel(product: ProductModel) {
        if (!product.isMtoProduct)
            return '';

        const currentChannel = this.getCurrentChannel();
        const inStore = product.channelEligibility?.["inStore"];
        const delivery = product.channelEligibility?.["delivery"];
        const pickUp = product.channelEligibility?.["pickUp"];

        switch (currentChannel) {
            case 'instore':
                return this.getInStoreLabel(inStore, pickUp, delivery);
            case 'delivery':
                return this.getDeliveryLabel(delivery, pickUp, inStore);
            case 'pickup':
                return this.getPickupLabel(pickUp, delivery, inStore);
            default:
                return '';
        }
    };

    /**
     * Retrieves the current user channel. If the application is in edit-flow mode
     * it attempts to retrieve the channel from the pending order stored in the OrderPreference cookie.
     * If no pending order is found, it defaults to the user's current channel.
     *
     * @returns The user's channel or the channel from the pending order.
     */
    private getCurrentChannel() {
        let channel = this.aemService.getUserChannel();
            
        // Check if there is an existing order/channel (using the cookie)
        const hasPendingOrder = !!(this.aemService.getOrderStoredIdCookie() && this.aemService.getOrderNumberCookie());
        if (hasPendingOrder) {
            const orderChannel : string  = this.aemService.getOrderPreferenceCookie();
            if (orderChannel) {
                channel = orderChannel.toLowerCase();
                if (channel === 'dug')
                    channel = 'pickup';
            }
        }
    
        return channel;
    }

    private getInStoreLabel(inStoreAvailable: boolean, pickUpAvailable: boolean, deliveryAvailable: boolean) {
        if (inStoreAvailable) return '';
        if (pickUpAvailable && !deliveryAvailable) return CHANNEL_LABEL_PICKUP_ONLY;
        if (deliveryAvailable && !pickUpAvailable) return CHANNEL_LABEL_DELIVERY_ONLY;
        return '';
    };

    private getDeliveryLabel(deliveryAvailable: boolean, pickUpAvailable: boolean, inStoreAvailable: boolean) {
        if (deliveryAvailable) return '';
        if (pickUpAvailable) return CHANNEL_LABEL_PICKUP_ONLY;
        if (inStoreAvailable) return CHANNEL_LABEL_INSTORE_ONLY;
        return '';
    };

    private getPickupLabel(pickUpAvailable: boolean, deliveryAvailable: boolean, inStoreAvailable: boolean) {
        if (pickUpAvailable) return '';
        if (deliveryAvailable) return CHANNEL_LABEL_DELIVERY_ONLY;
        if (inStoreAvailable) return CHANNEL_LABEL_INSTORE_ONLY;
        return '';
    };

    public isSlotValidAtCurrentTime(departmentsData: any[], departmentName: string, slotKey:string): boolean {
        if (!departmentsData || !departmentName) return true;
      
        const abSlotFromLS = localStorage.getItem(slotKey);
        const slotObj = abSlotFromLS ? JSON.parse(abSlotFromLS) : {};
        const slot = slotObj?.timeSlot;
        if (!slot) return true;
      
        const department = departmentsData?.find(
          dept => dept?.departmentName?.toLowerCase() === departmentName?.toLowerCase()
        );
        if (!department || !department?.dayOfWeek) return true;
      
        return this.isSlotWithinOperatingHours(department, slotObj);;
      
      }
      

    private isSlotWithinOperatingHours(department: any, slotObj?: { slot: string, timeSlot: number, userChannel: string }): boolean {
        if (!slotObj?.timeSlot) return true;
       
        // function to be modified after timezone issues are fixed
        // const prebookedTime = DateTime.fromMillis(slotObj.timeSlot).setZone(window['AB']?.storeFlagsData?.flags?.timezone);
        // targetDay = prebookedTime.weekdayLong;
        // selctedTimeInMinutes = (prebookedTime.hour * 60) + prebookedTime.minute;
        const prebookedTime = new Date(slotObj.timeSlot);
        const targetDay = prebookedTime.toLocaleString('en-US', { weekday: 'long' });
        const selctedTimeInMinutes = (prebookedTime.getHours() * 60) + prebookedTime.getMinutes();
        const dayConfig = department.dayOfWeek.find((day: any) => day?.day === targetDay);
        if (!dayConfig || !dayConfig.startHour || !dayConfig.endHour) return true;

        const deptStart = this.convertTimeStringToMinutes(dayConfig.startHour);
        const deptEnd = this.convertTimeStringToMinutes(dayConfig.endHour);
        return selctedTimeInMinutes >= deptStart && selctedTimeInMinutes < deptEnd;
    }
      

    private convertTimeStringToMinutes(timeStr: string): number {
        const hours = parseInt(timeStr.substring(0, 2), 10);
        const minutes = parseInt(timeStr.substring(2), 10);
        return hours * 60 + minutes;
    }

      
    public getBadgeToDisplay(isProductSubscribed, product): BadgeModel {
        if (isProductSubscribed) {
            return { badgeName: 'Subscribed', color: 'neutral', isStrikethrough: false, isBoldText: false };
        }
        return product?.badges?.[0] || {};
    }

    private showDisplayHoursForDeli(departments,departmentName,slotKey){
        const deliDepartment = departments?.find(department => department?.departmentName?.toLowerCase() === departmentName.toLowerCase());
        const abSlotFromLS = localStorage.getItem(slotKey);
        const slotObj = abSlotFromLS ? JSON.parse(abSlotFromLS) : {};
        const timeSlot = new Date(slotObj?.timeSlot);
        const targetDay = timeSlot.toLocaleString('en-US', { weekday: 'long' });

        const dayConfig = deliDepartment?.dayOfWeek?.find((day: any) => day?.day === targetDay);

        return { startHour: dayConfig?.startHour, endHour: dayConfig?.endHour };
    }

    public formatTimeSlots(slotKey) {
        const {startHour, endHour} = this.showDisplayHoursForDeli(window['AB']?.['storeFlagsData']?.['flags']?.['departmentsDetail'], 'Deli',slotKey) || {};
        
        const formatTime = (timeStr, includeMinutes = false) => {
            let hours;
            hours = parseInt(timeStr?.slice(0, 2), 10);
            const minutes = parseInt(timeStr?.slice(2), 10);
            
            const period = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            
            if (includeMinutes) {
                return `${hours}:${minutes?.toString().padStart(2, '0')} ${period}`;
            } else {
                return `${hours} ${period}`;
            }
        };
        
        return {
            shortFormat: `${formatTime(startHour)} to ${formatTime(endHour)}`,
            longFormat: `${formatTime(startHour, true)} - ${formatTime(endHour, true)}`,
            hyphinFormat: `${formatTime(startHour)}-${formatTime(endHour)}`
        };
    }
}


